export default __webpack_public_path__ + "static/media/green_bg.57744ec8.png";